import { BackgroundSection } from '@/layouts/DefaultLayout/components/BackgroundSection/BackgroundSection'
import { Content } from '@/layouts/DefaultLayout/components/Content/Content'

import { LoginForm } from '@/modules/login/components/LoginForm/LoginForm'

import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

export function Component() {
  return (
    <>
      <BackgroundSection image="login_image.png" />
      <Content>
        <Title variant="h1">Welcome back</Title>

        <Text>
          Nice to see you again! Please enter your details below to log in.
        </Text>

        <LoginForm />
      </Content>
    </>
  )
}

Component.displayName = 'Login'
